import { useIsAdminUser } from '@app/core/auth/authentication/hooks/useIsAdminUser';
import { useImpersonation } from './useImpersonationStore';

/** Returns true when the admin account is actively impersonating another user. */
export function useIsImpersonationOn() {
  const isAdminUser = useIsAdminUser();
  const { impersonatedUser } = useImpersonation();

  return isAdminUser && !!impersonatedUser;
}
